<template>
	<div>
		<h2 class="common__heading bottom-gap-lg">{{ header }}</h2>

		<checkbox
			:checkbox="checkboxes[0]"
			class="bottom-gap-lg"
			@click.native="onDisableCheckboxClick"
		></checkbox>

		<slide-down :active="checkboxes[0].isChecked">
			<form class="styled-form">
				<div class="styled-form__info styled-form__info--bg">
					<div class="o-grid o-grid--no-vgutter">
						<div class="o-grid__item o-1/2@largeTablet">
							<div class="styled-form__field">
								<label
									class="common__second-heading"
									v-bind:for="checkboxes[0].reasoning[0].id"
								>{{ checkboxes[0].reasoning[0].txt }}</label>

								<select
									class="styled-form__select"
									v-bind:id="checkboxes[0].reasoning[0].id"
									v-model="checkboxes[0].reasoning[0].value"
								>
									<option v-for="(option, index) in checkboxes[0].reasoning[0].options" :key="index" v-bind:value="option.id">{{ option.txt }}</option>
								</select>
							</div>
						</div>
					</div>

					<div>
						<label
							class="styled-form__label styled-form__label--thin"
							v-bind:for="checkboxes[0].reasoning[1].id"
						>{{ checkboxes[0].reasoning[1].txt }}</label>
						<textarea
							class="styled-form__textarea"
							v-bind:id="checkboxes[0].reasoning[1].id"
							v-model="checkboxes[0].reasoning[1].value"
							:style="{
								height: '95px'
							}"
						></textarea>
					</div>
				</div>
			</form>
		</slide-down>

		<div :class="['checkbox-wrapper', {'is-disabled': disabledGroup}]" v-show="false">
			<checkbox
				:checkbox="checkboxes[1]"
				class="bottom-gap-lg"
				@click.native="onLimitCheckboxClick"
			></checkbox>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import Checkbox from '../formFields/Checkbox.vue';
	import SlideDown from '../animations/SlideDown.vue'

	export default {
    components: {
      Checkbox,
      SlideDown
    },
    props: {
      header: {
        type: String,
        required: true
      },
    },
    computed: {
      ...mapState('onboarding', {
        form: state => state.form || {},
        disabledGroup: state => state.formGroups.disableGroup.heading.isDisabled,
        checkboxes: state => state.formGroups.disableGroup.checkboxes,
        optinGroup: state => state.formGroups.optinGroup.heading.isDisabled,
        optinCheckboxes: state => state.formGroups.optinGroup.checkboxes
      })
    },
    methods: {
      onDisableCheckboxClick() {
        // toggle checkbox
        const payload = {
          groupName: 'disableGroup',
          checkboxIndex: 0
        };
        const newState = !this.checkboxes[0].isChecked;
        this.$store.commit('onboarding/TOGGLE_CHECKBOX_STATE', payload);

        // disable all checkboxes
        this.$store.commit('onboarding/SET_DISABLE_STATE_FOR_ALL', newState);
      },
      onLimitCheckboxClick() {
        const payload = {
          groupName: 'disableGroup',
          checkboxIndex: 1
        };
        this.$store.commit('onboarding/TOGGLE_CHECKBOX_STATE', payload);
      },
      optinCheckboxClick() {
        const payload = {
          groupName: 'optinGroup',
          checkboxIndex: 0
        };
        this.$store.commit('onboarding/TOGGLE_CHECKBOX_STATE', payload);
      },
      checkboxClickHandler(groupName, checkboxIndex) {
        this.$store.commit('onboarding/TOGGLE_CHECKBOX_STATE', {groupName, checkboxIndex});
      }
    },
    created: function () {
      // pre populate existing selections
      if (this.form.isprimary == true || this.form.onboardingcomplete != 'Not Completed') {
        this.checkboxes[0].isChecked = this.form.ffa_donotbulkemail;
        this.checkboxes[0].reasoning[0].value = this.form.ffa_unsubscribereason;
        this.checkboxes[0].reasoning[1].value = this.form.ffa_unsubscribereasonother;
        this.checkboxes[1].isChecked = this.form.ffa_bulkemailfrequency;
        this.$store.commit('onboarding/SET_DISABLE_STATE_FOR_ALL', this.form.ffa_donotbulkemail);
      }

    }
  };
</script>

<style lang="scss" scoped>
	@import '~sass/_variables.scss';

	.checkbox-wrapper {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: $col-neutral--0;
      opacity: 0;
      visibility: hidden;
      transition-property: opacity, visibility;
      transition-duration: $ttime;
      transition-delay: 0ms, $ttime;
    }

    &.is-disabled:after {
      visibility: visible;
      opacity: 0.6;
      transition-delay: 0ms, 0ms;
    }
  }
</style>